/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { UpdateClusterActions, UpdateClusterActionTypes, UpdateClusterState } from './types';

export const initialState: UpdateClusterState = {
  serviceType: 'postgres',
};

export function updateCluster(state = initialState, action: UpdateClusterActionTypes): UpdateClusterState {
  switch (action.type) {
    case UpdateClusterActions.OPEN_UPDATE_CLUSTER_OVERLAY: {
      const { serviceType } = action.payload;
      return {
        ...state,
        serviceType,
      };
    }
    case UpdateClusterActions.CLOSE_UPDATE_CLUSTER_OVERLAY:
      return {
        ...state,
      };
    default:
      return state;
  }
}
